import { useLocalizableInput } from '@hooks/useLocalizableInput'
import { Lang } from '@models/Lang'
import { Form, Input, Select, Space } from 'antd'
import { langList, langsAsOptions, langsByCode } from '../../factories/Utils'
import FormItemErrors from '../FormItemErrors'
import { LocalizableInputProps } from './Input'

const ANTDTextArea = Input.TextArea

export const TextArea = ({
  selectedLangCode: selectedLangProps,
  name,
  namePrefix,
  label,
  noStyle = false,
  rules = [],
  max,
  placeholder,
  hideLangSelector = false,
}: LocalizableInputProps) => {
  const {
    selectedLangCode,
    setSelectedLangCode,
    formItemName,
    formInstance,
    value,
    showLangSelector,
    showLangFlag,
  } = useLocalizableInput({
    selectedLangProps,
    name,
    namePrefix,
    hideLangSelector,
  })

  return (
    <Space orientation="vertical" className="w-full" style={{ rowGap: 0 }}>
      <Form.Item
        rootClassName="localized-textarea-label"
        style={{ width: '100%' }}
        help={false}
        name={formItemName(selectedLangCode)}
        noStyle={noStyle}
        className="mt-0"
        rules={rules}
        label={
          <Space className="w-full space-between">
            {label}
            {/* A pinned field always states its language: that label is not a
                selector, it just says which locale the field edits. */}
            {selectedLangProps !== undefined ? (
              <>{`${langsByCode[selectedLangProps].flag} ${langsByCode[selectedLangProps].name}`}</>
            ) : showLangSelector ? (
              <Select
                defaultValue={selectedLangCode}
                size="small"
                style={{
                  width: 120,
                }}
                variant="filled"
                onChange={(value) => {
                  setSelectedLangCode(value)
                }}
                onClick={(e) => e.preventDefault()}
                options={langsAsOptions}
              />
            ) : showLangFlag ? (
              // The header selector drives the language: show a passive flag so
              // the field still states which locale it edits.
              <>{langsByCode[selectedLangCode].flag}</>
            ) : undefined}
          </Space>
        }
      >
        {noStyle && showLangSelector && selectedLangProps === undefined && (
          <Select
            defaultValue={selectedLangCode}
            size="small"
            style={{
              width: 120,
              marginBottom: 15,
            }}
            variant="filled"
            onChange={(value) => {
              setSelectedLangCode(value)
            }}
            onClick={(e) => e.preventDefault()}
            options={langsAsOptions}
          />
        )}
        <ANTDTextArea
          autoSize={{ minRows: 4, maxRows: 20 }}
          placeholder={placeholder}
          maxLength={max}
          showCount={max != undefined}
          value={value}
          onChange={(v) => {
            formInstance.setFieldValue(
              formItemName(selectedLangCode),
              v.target.value
            )
          }}
        />
      </Form.Item>

      {langList.map((lang: Lang) => (
        <Form.Item
          hidden
          key={lang.id}
          name={formItemName(lang.code)}
          className="m-0"
          rules={rules}
        >
          <Input type="hidden" />
        </Form.Item>
      ))}

      <FormItemErrors namePrefix={namePrefix} name={name} />
    </Space>
  )
}
export type TextAreaType = { TextArea: typeof TextArea }
